import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_PX: Record<NonNullable<LogoProps['size']>, number> = {
  sm: 24,
  md: 32,
  lg: 40,
};

export function Logo({ className, size = 'md' }: LogoProps) {
  const height = SIZE_PX[size];
  return (
    <svg
      viewBox="0 0 312.45 87.56"
      height={height}
      role="img"
      aria-label="Underline"
      className={cn('block w-auto text-foreground', className)}
      preserveAspectRatio="xMinYMid meet"
    >
      <g fill="currentColor">
        <path d="M6.38,36.17c3.56,2.27,8.43,3.62,14.61,4.06,2.76.19,5.49.28,8.2.28,6.7,0,12.06-.51,16.09-1.53,8.74-2.18,13.11-7.41,13.11-15.72V0h-15.86v21.56c0,1.46-.28,2.65-.85,3.58s-1.32,1.65-2.27,2.17c-.95.52-2,.89-3.16,1.11-1.16.22-2.36.35-3.59.4-1.23.05-2.38.07-3.46.07-3.08,0-5.44-.15-7.06-.45-4.18-.81-6.27-3.11-6.27-6.89V0H0v23.26c0,5.86,2.13,10.17,6.38,12.91Z" />
        <polygon points="79.85 16.03 102.75 39.15 122.38 39.15 122.38 0 106.52 0 106.52 23.09 83.6 0 63.99 0 63.99 39.15 79.85 39.15 79.85 16.03" />
        <path d="M167.99,39.15c2.89,0,5.73-.47,8.51-1.4,2.78-.94,5.04-2.2,6.78-3.79,4.35-4.03,6.53-8.82,6.53-14.38s-2.18-10.36-6.53-14.38c-1.74-1.59-4-2.85-6.78-3.79-2.78-.94-5.62-1.4-8.51-1.4h-38.16v39.15l38.1.14.06-.14ZM145.69,27.18v-15.21h21.02c1.74,0,3.27.47,4.6,1.42,1.74,1.27,2.61,3.33,2.61,6.18s-.87,4.89-2.61,6.16c-1.32.96-2.86,1.45-4.6,1.45h-21.02Z" />
        <polygon points="247.95 27.66 208.03 27.66 208.03 23.77 245.34 23.77 245.34 15.15 208.03 15.15 208.03 11.46 247.5 11.46 247.5 0 192.18 0 192.18 39.15 247.95 39.15 247.95 27.66" />
        <path d="M310.51,36.27c-.5-1.39-.81-3.8-.92-7.22-.11-3.42-2.01-5.87-5.7-7.35,4.26-2.02,6.38-5.3,6.38-9.82,0-1.08-.15-2.27-.44-3.59-.29-1.31-.99-2.62-2.09-3.93-2.48-2.91-6.96-4.37-13.45-4.37h-42.19v39.15h15.86v-10.53h17.96c2.1,0,3.71.17,4.82.51s1.79,1.18,2.01,2.52c.15.93.23,1.88.23,2.85s.07,1.88.21,2.71c.14.83.49,1.48,1.04,1.93h18.21c-.79-.53-1.44-1.49-1.94-2.88ZM293.86,15.48c-.29.44-.84.83-1.65,1.16-.8.33-1.94.5-3.42.5h-20.82v-5.67h20.82c2.44,0,4.05.35,4.82,1.05.45.42.68,1.01.68,1.79,0,.34-.15.73-.44,1.18Z" />
        <polygon points="53.36 75.59 15.86 75.59 15.86 48.41 0 48.41 0 87.56 53.36 87.56 53.36 75.59" />
        <rect x="56.67" y="48.41" width="15.86" height="39.15" />
        <polygon points="79.98 48.41 79.98 87.56 95.84 87.56 95.84 64.44 118.74 87.56 138.37 87.56 138.37 48.41 122.51 48.41 122.51 71.5 99.58 48.41 79.98 48.41" />
        <polygon points="161.68 72.18 198.98 72.18 198.98 63.56 161.68 63.56 161.68 59.87 201.14 59.87 201.14 48.41 145.82 48.41 145.82 87.56 201.59 87.56 201.59 76.07 161.68 76.07 161.68 72.18" />
      </g>
      <motion.rect
        x="209.2"
        y="76.91"
        width="75.27"
        height="10.65"
        fill="var(--primary)"
        animate={{ opacity: [1, 0.25, 1] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
      />
    </svg>
  );
}
